import script from "./RaceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RaceCard.vue?vue&type=script&setup=true&lang=ts"

import "./RaceCard.vue?vue&type=style&index=0&id=fa1944c8&lang=css"

const __exports__ = script;

export default __exports__